
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { PasswordForm, employeeApis, InvalidParam } from '../../api';
import { AESFunction } from '@/common/cryptoAES';
import { CookieFunction } from '@/common/cookie';

@Component
export default class MySettings extends Vue {
  readonly labelWidth = '6rem';
  readonly rules = {
    cur_password: { required: true, message: '请输入当前密码' },
    new_password: {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (value == this.pwdData.cur_password) {
          callback(new Error('不能与当前密码一致'));
        } else {
          callback();
        }
      }
    },
    repeat_new_password: {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (value != this.pwdData.new_password) {
          callback(new Error('新密码不一致'));
        } else {
          callback();
        }
      }
    }
  };

  @Ref('password-form') passwrodForm!: ElForm;

  pwdData: PasswordForm = {} as PasswordForm;
  errors = {};

  async submitPassword() {
    this.passwrodForm.validate(valid => {
      if (valid) {
        this.savePassword();
      }
    });
  }

  async savePassword() {
    this.errors = {};
    try {
      const encryptStr = new this.$jsEncrypt();
      const pubKeyResult = await employeeApis.getPublicKey();
      const pubKey = pubKeyResult.key;
      const timestamp = pubKeyResult.timestamp;
      encryptStr.setPublicKey(pubKey); // 设置 加密公钥
      const cur_data = encryptStr.encrypt(this.pwdData.cur_password.toString() + '&' + timestamp);
      const new_data = encryptStr.encrypt(this.pwdData.new_password.toString() + '&' + timestamp);
      const new_repeat_data = encryptStr.encrypt(this.pwdData.repeat_new_password.toString() + '&' + timestamp);
      const pwdData = {
        cur_password: cur_data,
        new_password: new_data,
        repeat_new_password: new_repeat_data
      };
      await employeeApis.updatePassword(pwdData);
      if (CookieFunction.getCookie('username') && CookieFunction.getCookie('passwd')) {
        CookieFunction.setCookie('passwd', AESFunction.encrypt(this.pwdData.new_password));
      }
      this.pwdData = {} as PasswordForm;
      this.passwrodForm.resetFields();
      // 如果是内部员工提示一下密码的用途
      if (!this.$currentIsExternal()) {
        try {
          await this.$alert(this.$passwordTips, '提示', {
            confirmButtonText: '确认并继续',
            type: 'warning'
          });
        } catch {}
      }
      this.$router.push('/');
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
  }
}
